import { JevisSelectOption } from "../components/ui/AppSelect";

/** Normalizza risposte API/json in opzioni per react-select. */
export function normalizeSelectOptions(data: unknown): JevisSelectOption[] {
  if (!data) return [];

  if (Array.isArray(data)) {
    return data
      .map((item) => {
        if (typeof item === "string") {
          const t = item.trim();
          return t ? { value: t, label: t } : null;
        }
        if (item && typeof item === "object") {
          const obj = item as Record<string, unknown>;
          const value = String(obj.value ?? obj.label ?? "").trim();
          const label = String(obj.label ?? obj.value ?? "").trim();
          if (!value) return null;
          return { value, label: label || value };
        }
        return null;
      })
      .filter((o): o is JevisSelectOption => o !== null);
  }

  if (typeof data === "object") {
    const obj = data as Record<string, unknown>;
    for (const key of ["servizi", "esiti", "associati", "items", "data"]) {
      if (key in obj) return normalizeSelectOptions(obj[key]);
    }
  }

  return [];
}

/** Include il valore corrente se assente dalla lista (es. voce legacy). */
export function withCurrentOption(
  options: JevisSelectOption[],
  currentValue: string
): JevisSelectOption[] {
  const v = currentValue?.trim();
  if (!v || options.some((o) => o.value === v)) return options;
  return [{ value: v, label: v }, ...options];
}
